import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { HttpUtilsService } from "../../_base/crud";
import { ValuationReportModel } from "../_models/valuation-report.model";
import { SubdomainService } from "../../_base/subdomain.service";


@Injectable()
export class ValuationReportService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/toes/valuation/report`;
	constructor(
        private http: HttpClient,
        private authService: MadAuthService,
        private subDomainService: SubdomainService
    ) {}

    getReports(tpID: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + 'ByTp' + `/${tpID}`, {
            headers: httpHeaders
        }).pipe(catchError(err => {
            return EMPTY
        }));
    }

    getReportsMultimedia(tpID: number): Observable<any> {
        return this.http.get<any>(
            `${environment.baseApiUrl}api/${this.subDomainService.subDomain}/multimedia/toes/valuation/reportByTp` + `/${tpID}`, 
            {
        }).pipe(catchError(err => {
            return EMPTY
        }));
    }

    getReport(id: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.get<any>(this.API_URL + `/${id}`, {
            headers: httpHeaders
        });
    }

    createValuationReport(report: ValuationReportModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.post<any>(this.API_URL, report, {
            headers: httpHeaders
        });
    }

    updateReport(report: ValuationReportModel): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.post<any>(this.API_URL + `/${report.id}`, report, {
            headers: httpHeaders
        });
    }

    deleteReport(id: number): Observable<any> {
        const httpHeaders = this.authService.getAuthHeaders();
        return this.http.delete<any>(this.API_URL + `/${id}`, {
            headers: httpHeaders
        });
    }
}